export default "__VITE_ASSET__BdGa8CPw__"